import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

export const createUserDocument = async (uid, email) => {
  try {
    await setDoc(doc(db, 'users', uid), {
      email,
      createdAt: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error creating user record:', error);
    throw new Error('Failed to create user profile');
  }
};

export const updateUserProfile = async (uid, profileData) => {
  try {
    await updateDoc(doc(db, 'users', uid), {
      ...profileData,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw new Error('Failed to update user profile');
  }
};

export const checkProfileCompletion = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', uid));
    if (!userDoc.exists()) return false;
    const userData = userDoc.data();
    return !!(userData.firstName && userData.websiteUrl);
  } catch (error) {
    console.error('Error checking profile completion:', error);
    return false;
  }
};

export const getUserDoc = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', uid));
    if (!userDoc.exists()) return null;
    return userDoc.data();
  } catch (error) {
    console.error('Error fetching user doc:', error);
    return null;
  }
};
